import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1fb1b80a")

_pushScopeId("data-v-1fb1b80a")
const _hoisted_1 = {
  key: 0,
  id: "expired-schedule",
  "data-test": "expired-warning"
}
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "table-header p-d-flex " }
const _hoisted_6 = { class: "p-input-icon-left p-mr-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withId(() => [
      (_ctx.showExpired && _ctx.expired)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("p", null, _toDisplayString(_ctx.$t('kpi.kpiScheduler.expiredInterval')), 1),
            _createVNode("i", {
              class: "fa fa-times-circle",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showExpired = false))
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataTable, {
        value: _ctx.kpisList,
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
        globalFilterFields: _ctx.kpiCardDescriptor.globalFilterFields,
        responsiveLayout: "stack",
        breakpoint: "960px",
        "data-test": "kpi-table"
      }, {
        header: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                type: "text",
                placeholder: _ctx.$t('common.search'),
                "data-test": "filterInput"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode(_component_Button, {
              id: "add-kpi-associations-button",
              class: "kn-button kn-button--primary",
              label: _ctx.$t('kpi.kpiScheduler.addKpiAssociation'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addKpiAssociationVisible = true))
            }, null, 8, ["label"])
          ])
        ]),
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpiCardDescriptor.columns, (col) => {
            return (_openBlock(), _createBlock(_component_Column, {
              class: "kn-truncated",
              field: col.field,
              header: _ctx.$t(col.header),
              key: col.field,
              sortable: true
            }, null, 8, ["field", "header"]))
          }), 128)),
          _createVNode(_component_Column, {
            style: _ctx.kpiCardDescriptor.table.iconColumn.style
          }, {
            body: _withId((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: ($event: any) => (_ctx.deleteKpiAssociationConfirm(slotProps.data.id)),
                "data-test": 'delete-button-' + slotProps.data.id
              }, null, 8, ["onClick", "data-test"])
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }, 8, ["value", "filters", "globalFilterFields"]),
      _createVNode(_component_Dialog, {
        style: _ctx.kpiCardDescriptor.dialog.style,
        visible: _ctx.addKpiAssociationVisible,
        modal: true,
        class: "p-fluid kn-dialog--toolbar--primary",
        closable: false
      }, {
        header: _withId(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
            start: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiScheduler.saveKpiAssociation')), 1)
            ]),
            end: _withId(() => [
              _createVNode(_component_Button, {
                class: "kn-button p-button-text p-m-2",
                label: _ctx.$t('common.close'),
                onClick: _ctx.closeKpiAssociations
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Button, {
                class: "kn-button p-button-text",
                label: _ctx.$t('common.save'),
                onClick: _ctx.addKpiAssociations
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.allKpiList,
            selection: _ctx.selectedKpiAssociations,
            "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedKpiAssociations = $event)),
            class: "p-datatable-sm kn-table",
            dataKey: "id",
            filters: _ctx.filters,
            "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters = $event)),
            globalFilterFields: _ctx.kpiCardDescriptor.globalFilterFields,
            responsiveLayout: "stack",
            breakpoint: "960px"
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.filters['global'].value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters['global'].value = $event)),
                    type: "text",
                    placeholder: _ctx.$t('common.search'),
                    "data-test": "filterInput"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                headerStyle: "width: 3em"
              }),
              _createVNode(_component_Column, {
                class: "kn-truncated",
                field: "name",
                header: _ctx.$t('kpi.kpiScheduler.kpiName'),
                key: "name",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                class: "kn-truncated",
                field: "category.valueCd",
                header: _ctx.$t('common.category'),
                key: "category.valueCd",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                class: "kn-truncated",
                field: "dateCreation",
                header: _ctx.$t('kpi.kpiScheduler.kpiName'),
                key: "dateCreation",
                sortable: true
              }, {
                body: _withId((slotProps) => [
                  _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.dateCreation)), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                class: "kn-truncated",
                field: "author",
                header: _ctx.$t('common.author'),
                key: "author",
                sortable: true
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "selection", "filters", "globalFilterFields"])
        ]),
        _: 1
      }, 8, ["style", "visible"])
    ]),
    _: 1
  }))
})